import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';
import investmentFilterLang from '../../../langs/investmentFilterLang';
import { TInvestFundDomainTag } from '../../../../../types/fund/TInvestFundDomainTag';

type CFiltersDomainSelectProps = {
	optionsDomains: { id: TInvestFundDomainTag; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
};

const CFiltersDomainSelect = (props: CFiltersDomainSelectProps) => {
	const { optionsDomains, filters, onChange } = props;

	const { t } = useTranslation();

	return (
		<CAppFilterSelect
			className="filter-domain"
			label={t(investmentFilterLang.domain.tag)}
			value={filters && filters.domainTag ? optionsDomains.find((x) => x.id === filters.domainTag) : null}
			onChange={(val: { id: TInvestFundDomainTag; name: string }) => {
				onChange({
					...filters,
					domainTag: val ? val.id : null,
				});
			}}
			size="small"
			options={optionsDomains}
		/>
	);
};

export default CFiltersDomainSelect;
